import {
  type BudgetTemplateLine,
  Frequency,
  FrequencyPerYear,
} from 'loot-core/src/shared/budget-template';
import { type CategoryGroupEntity } from 'loot-core/src/types/models';
import { type BudgetTemplateLineEntity } from 'loot-core/src/types/models/budget-template';

import { type BudgetTemplateCategoryItem } from './types';

export enum VIEW_MODE {
  COMBINED = 'combined',
  ONLY_MONTHS = 'onlyMonths',
  // ONLY_BUDGET = 'onlyBudget'
}

export function computeDictOfBudgetLines(
  items: BudgetTemplateCategoryItem<CategoryGroupEntity>[],
  budgetLines: BudgetTemplateLineEntity[],
) {
  const dict: { [id: string]: Partial<BudgetTemplateLine> } = {};
  for (const item of items) {
    let budgetLine: Partial<BudgetTemplateLine> = budgetLines.find(
      o => o.category === item.value.id,
    );
    if (!budgetLine) {
      budgetLine = {
        category: item.value.id,
        amount: 0,
        frequency: Frequency.Monthly,
      };
    }
    dict[budgetLine.category] = budgetLine;
  }
  return dict;
}

export function getYearlyBudget(budgetLine: Partial<BudgetTemplateLine>) {
  if (!budgetLine.frequency) {
    return 0;
  }

  return (
    Math.round(budgetLine.amount ?? 0) * FrequencyPerYear[budgetLine.frequency]
  );
}

export function getMonthlyBudget(budgetLine: Partial<BudgetTemplateLine>) {
  return Math.round(getYearlyBudget(budgetLine) / 12);
}

export function getRandomChartColor(str: string) {
  for (
    var i = 0, hash = 0;
    i < str.length;
    hash = str.charCodeAt(i++) + ((hash << 5) - hash)
  );
  const color = Math.floor(
    Math.abs(((Math.sin(hash) * 10000) % 1) * 16777216),
  ).toString(16);
  return '#' + Array(6 - color.length + 1).join('0') + color;
}
